import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';

const AddTaskModal = ({
    show,
    onHide,
    selectedProject,
    setSelectedProject,
    selectedTaskList,
    setSelectedTaskList,
    startDate,
    setStartDate,
    dueDate,
    setDueDate,
    selectedPriority,
    setSelectedPriority,
    selectedPrivacy,
    setSelectedPrivacy,
    selectedAssignees,
    setSelectedAssignees,
    description,
    setDescription,
    notifyByEmail,
    setNotifyByEmail,
    projectOptions,
    taskListOptions,
    priorityOptions,
    privacyOptions,
    assigneeOptions
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered  size="lg">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Add New Task</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className='gy-3'>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Select a Project <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedProject}
                                        onChange={setSelectedProject}
                                        options={projectOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Select a Task List <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedTaskList}
                                        onChange={setSelectedTaskList}
                                        options={taskListOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isDisabled={!selectedProject}
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Task Name <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control type="text" />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Start Date <span className='text-danger'>*</span></Form.Label>
                                    <Flatpickr
                                        value={startDate}
                                        onChange={([date]) => setStartDate(date)}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                            time_24hr: false
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Due Date <span className='text-danger'>*</span></Form.Label>
                                    <Flatpickr
                                        value={dueDate}
                                        onChange={([date]) => setDueDate(date)}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            minDate: startDate,
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                            time_24hr: false
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Estimated Time</Form.Label>
                                    <Form.Control type="text" />
                                </Form.Group>
                                <Form.Text className="p-tag fs-12">
                                    Please enter the estimated time in hours and minutes (e.g., 4h 30m).
                                </Form.Text>
                                <div className='d-flex justify-content-start mt-0'>
                                    <Button variant="link" className='text-decoration-none me-2'>2h</Button>
                                    <Button variant="link" className='text-decoration-none me-2'>1h</Button>
                                    <Button variant="link" className='text-decoration-none me-2'>45m</Button>
                                    <Button variant="link" className='text-decoration-none me-2'>30m</Button>
                                    <Button variant="link" className='text-decoration-none'>15m</Button>
                                </div>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Priority <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedPriority}
                                        onChange={setSelectedPriority}
                                        options={priorityOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Privacy</Form.Label>
                                    <Select
                                        value={selectedPrivacy}
                                        onChange={setSelectedPrivacy}
                                        options={privacyOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Assignees <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedAssignees}
                                        onChange={setSelectedAssignees}
                                        options={assigneeOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control 
                                        as="textarea" 
                                        rows={3}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        label="Notify assignees by email"
                                        checked={notifyByEmail}
                                        onChange={(e) => setNotifyByEmail(e.target.checked)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-between'>
                <Button variant="link" className='text-danger text-decoration-none' onClick={onHide}>
                    Cancel
                </Button>
                <div>
                    <Button variant="primary" className='me-3' onClick={onHide}>
                        Create & Another
                    </Button>
                    <Button variant="primary" onClick={onHide}>
                        Add Task
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default AddTaskModal;
